/**
 * Detect if the app is embedded in an iframe (e.g., on CloudRealtor.io)
 * This is used to disable scroll/focus behaviors that can affect the parent page
 */
export const isEmbedded = (() => {
  if (typeof window === 'undefined') return false;
  try {
    const hasEmbedParam = new URLSearchParams(window.location.search).get('embed') === 'true';
    // window.self !== window.top can throw SecurityError in cross-origin iframes
    let isInIframe = false;
    try {
      isInIframe = window.self !== window.top;
    } catch (e) {
      // SecurityError means we're in a cross-origin iframe
      isInIframe = true;
    }
    const result = hasEmbedParam || isInIframe;
    if (result) {
      console.log('[CloudMortgage] Running in embedded/iframe mode - scroll behaviors disabled');
    }
    return result;
  } catch (e) {
    return false;
  }
})();
